module.exports = __webpack_public_path__ + "img/tn-stock-8.dd3dd763.jpeg";